import React, { createContext, useContext, useState } from "react";

export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // Stato iniziale: recupera tutto l'oggetto user da localStorage
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // Login: aggiorna stato e salva in localStorage
  const login = ({ accessToken, refreshToken, ruolo, username }) => {
    const userData = { accessToken, refreshToken, ruolo, username }; // <-- aggiunto username
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    
  };

  // Logout: pulisce stato e localStorage
  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
